import type { Address } from './address'
import type { CallReport } from './callReport'
import type { Subscription } from './subscription'
import type { User } from './user'
import type { FamilyMember } from './family'

export interface Customer {
    id: string
    number: string
    user?: User
    parent?: Customer
    family_members?: FamilyMember[]
    addresses?: Address[]
    reports?: CallReport[]
    subscription_id?: string
    subscriptions?: Subscription[]
    first_name: string
    middle_name?: string
    last_name?: string
    avatar?: string
    phone?: string
    email?: string
    birth_date?: string
    gender?: Gender
    blood_type?: BloodType
    chronic_diseases?: string
    chronic_medication?: string
    surgeries?: string
    allergies?: string
    tags?: string[]
    policy_holder?: string
    metadata?: {
        emergency_contact?: string
        emergency_phone?: string
        alternate_phone?: string
    }
    updated_at: string
}

export enum Gender {
    female = 'female',
    male = 'male',
}

export enum BloodType {
    aPos = 'A+',
    aNeg = 'A-',
    bPos = 'B+',
    bNeg = 'B-',
    abPos = 'AB+',
    abNeg = 'AB-',
    oPos = 'O+',
    oNeg = 'O-',
    unknown = 'Unknown',
}
